import React, { useMemo } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router';
import useUserAuth from '../../utils';
import Tabs from './Components/Tabs';
import Drafts from './Components/DraftsPage';
import SavedTemplates from './Components/SavedTemplatesPage';
import SharedTemplates from './Components/SharedTemplatesPage';
import SavedAudiences from './Components/SavedAudiencesPage';
import MediaManager from './Components/MediaManager';
import { useIsFeatureEnabled } from '../../libs/feature-toggles/react';
import Feature from '../../infrastructure/features';
import {
  ACTIVE,
  SCHEDULED,
  ARCHIVED,
  AUDIENCES_TAB,
  DATE,
  DRAFTS,
  MEDIA_MANAGER,
  FAVOURITED,
  NAME,
  SAVED_AUDIENCES,
  SAVED_TEMPLATES,
  SAVED_TEMPLATES_TAB,
  SENT,
  SHARED_TEMPLATES,
  SHARED_TEMPLATES_TAB,
  MEDIA_MANAGER_TAB,
} from './Components/_utils/constants';

const Draft = () => {
  const location = useLocation();
  useUserAuth();
  const isMediaManagerFeatureEnabled = useIsFeatureEnabled(
    Feature.MEDIA_MANAGER
  );

  const renderedTabs = useMemo(() => {
    const { apply, tab } = queryString.parse(location.search);
    const savedTemplatesTabContent = {
      menuItemName: SAVED_TEMPLATES,
      content: SavedTemplates,
      tab: SAVED_TEMPLATES_TAB,
      sort: [DATE, NAME],
      filter: [ACTIVE, ARCHIVED, FAVOURITED],
    };
    const sharedTemplatesTabContent = {
      menuItemName: SHARED_TEMPLATES,
      content: SharedTemplates,
      tab: SHARED_TEMPLATES_TAB,
    };
    const savedAudiencesTabContent = {
      menuItemName: SAVED_AUDIENCES,
      content: SavedAudiences,
      tab: AUDIENCES_TAB,
      sort: [DATE, NAME],
      filter: [ACTIVE, ARCHIVED, FAVOURITED],
    };
    const mediaManager = {
      menuItemName: MEDIA_MANAGER,
      content: MediaManager,
      tab: MEDIA_MANAGER_TAB,
    };
    // applying a saved audience to a current draft audience
    if (apply === '1' && tab === 'audiences') {
      return [savedAudiencesTabContent];
      // applying a saved design or shared design to a current draft
    } else if (apply === '1') {
      return [savedTemplatesTabContent, sharedTemplatesTabContent];
    } else {
      const tabs = [
        {
          menuItemName: DRAFTS,
          content: Drafts,
          sort: [DATE, NAME],
          filter: [ACTIVE, SCHEDULED, SENT, ARCHIVED],
        },
        savedTemplatesTabContent,
        sharedTemplatesTabContent,
        savedAudiencesTabContent,
      ];

      if (isMediaManagerFeatureEnabled) {
        tabs.push(mediaManager);
      }

      return tabs;
    }
  }, [location.search]);

  return <Tabs content={renderedTabs} />;
};

export default Draft;
